import React from "react";
import { useTheme } from "styled-components";

const Cards = () => {
  const theme = useTheme();
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.938 5.625H2.813a.563.563 0 0 0-.563.563v7.875c0 .31.252.562.563.562h10.125c.31 0 .562-.252.562-.562V6.187a.56.56 0 0 0-.562-.562"
        stroke={theme.text.text}
        stroke-width="1.125"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.5 3.375h10.688a.56.56 0 0 1 .562.563v8.437"
        stroke={theme.text.text}
        stroke-width="1.125"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default Cards;
